<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="剧本名称" prop="scriptName" >
        <a-button type="dashed" @click="showBindScript" danger v-if="form.scriptName">
          <span>{{ form.scriptName }}</span>
        </a-button>
        <a-button type="dashed" @click="showBindScript" danger v-if="!form.scriptName">
          <span style="color: dodgerblue"> 绑定剧本</span>
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="需要完成的场次" prop="requiredCount" >
        <a-input-number v-model="form.requiredCount" :min="0" :step="1" :precision="0" placeholder="请输入需要完成的场次" />
      </a-form-model-item>
      <a-form-model-item label="返现金额" prop="rebateAmount" >
        <a-input-number v-model="form.rebateAmount" :min="0" :step="1" :precision="0" placeholder="请输入返现金额" />
      </a-form-model-item>
      <a-form-model-item label="限制领取次数(0表示不限次数)" prop="limitCount" >
        <a-input-number v-model="form.limitCount" :min="0" :step="1" :precision="0" placeholder="请输入限制领取次数(0表示不限次数)" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <index-script-modal
      ref="IndexScriptModal"
      :isPlayedScript="true"
      @select="indexScriptModalSelect"
      @selectName="indexScriptModalName"
    ></index-script-modal>
  </a-drawer>
</template>

<script>
import IndexScriptModal from '@/components/Script/IndexScriptModal.vue'
import OssMultiUpload from '@/views/script/script/modules/OssMultiUpload.vue'
import OssMultiUploadSingle from '@/views/script/script/modules/OssMultiUploadSingle.vue'
import { addRebateActivityTask, getRebateActivityTask, updateRebateActivityTask
} from '@/api/played/rebateActivity'

export default {
  name: 'CreateRebateActivityTask',
  props: {
  },
  components: {
    OssMultiUploadSingle,
    OssMultiUpload,
    IndexScriptModal
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        activityId: null,
        scriptId: null,
        scriptName: null,
        requiredCount: null,
        rebateAmount: null,
        limitCount: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        scriptName: [
          { required: true, message: '请绑定剧本', trigger: 'blur' }
        ],
        requiredCount: [
          { required: true, message: '请输入需要完成的场次', trigger: 'blur' }
        ],
        rebateAmount: [
          { required: true, message: '请输入返现金额', trigger: 'blur' }
        ],
        limitCount: [
          { required: true, message: '请输入限制领取次数(0表示不限次数)', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    indexScriptModalSelect(ids) {
      this.form.scriptId = ids
    },
    indexScriptModalName(name) {
      this.form.scriptName = name
    },
    showBindScript: function() {
      this.$refs.IndexScriptModal.open()
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        activityId: null,
        scriptId: null,
        scriptName: null,
        requiredCount: null,
        rebateAmount: null,
        limitCount: null
      }
    },
    /** 新增按钮操作 */
    handleAdd (activityId) {
      this.reset()
      this.form.activityId = activityId
      this.formType = 1
      this.open = true
      this.formTitle = '新增返现活动任务'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids, activityId) {
      this.reset()
      this.form.activityId = activityId
      this.formType = 2
      const id = row ? row.id : ids
      getRebateActivityTask(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改返现活动任务'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateRebateActivityTask(this.form).then(() => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addRebateActivityTask(this.form).then(() => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
